/*!

 File: helper-scrollit.js
 Author: Mozilla
 Version: 1.0.3
 JS Dependencies:

 Description:
    Helper function for animated scroll

*/

function scrollIt(elTarget, duration, offset, callback) {

    if(elTarget != null){

        // Easing functions (not all)
        var easings = {
            linear: function linear(t) {
                return t;
            },
            easeInQuad: function easeInQuad(t) {
                return t * t;
            },
            easeOutQuad: function easeOutQuad(t) {
                return t * (2 - t);
            },
            easeInOutQuad: function easeInOutQuad(t) {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            }
        };

        var start = window.pageYOffset;
        var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

        var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
        var elTargetOffset = typeof elTarget === 'number' ? elTarget : elTarget.offsetTop;
        var elTargetOffsetToScroll = Math.round(documentHeight - elTargetOffset < windowHeight ? documentHeight - windowHeight : elTargetOffset);

        // Take into account floating header
        // If less than zero will get stuck in loop
        if(offset && elTargetOffsetToScroll > offset){
            elTargetOffsetToScroll -= offset;
        }


        // Just jump if animation isn't supported
        if (!window.requestAnimationFrame) {
            window.scroll(0, elTargetOffsetToScroll);
            // Run Callback function
            if (typeof callback === 'function'){
                callback();
            }
            return;
        }

        // Animation
        function scroll() {
            var now = 'now' in window.performance ? performance.now() : new Date().getTime();
            var time = Math.min(1, ((now - startTime) / duration));
            var timeFunction = easings['easeInOutQuad'](time);
            window.scroll(0, Math.ceil((timeFunction * (elTargetOffsetToScroll - start)) + start));
            // to nearest pixel
            if (window.pageYOffset > (elTargetOffsetToScroll-1) && window.pageYOffset < (elTargetOffsetToScroll+1) ) {
                // Run Callback function
                if (typeof callback === 'function'){
                    callback();
                }
                return;
            }
            requestAnimationFrame(scroll);
        }

        // Go!
        scroll();
    }else{
        console.log('scrollIt needs a target!');
    }

}
